import React from 'react';
import { Button, ConfigProvider, theme } from 'antd';

/**
 * Botón primary con `colorSuccess` del tenant (verde de CTA "crear/generar").
 *
 * Implementación: ConfigProvider local overridea `colorPrimary` por el
 * `colorSuccess` resuelto del theme activo. Antd gestiona hover/focus/disabled
 * automaticamente — más limpio que inline style + onMouseEnter/Leave.
 *
 * Uso:
 *   <SuccessButton onClick={...} icon={...}>Crear ODT</SuccessButton>
 *
 * Todas las props de `<Button>` son pasadas. `type` queda forzado a "primary".
 */
export default function SuccessButton({ type, ...props }) {
  const { token } = theme.useToken();
  return (
    <ConfigProvider theme={{ token: { colorPrimary: token.colorSuccess } }}>
      <Button type="primary" {...props} />
    </ConfigProvider>
  );
}
